import http from "@/utils/request";
export default {
    getWechatLoginQrCode: (data, headers) => http.get("/apps/pc/getWechatLoginQrCode", data, { headers }),
    getWxPcLoginInfo: (data, headers) => http.get("/apps/pc/getWxPcLoginInfo", data, { headers }),
    smsCode: (data, headers) => http.post("/apps/verify/send/smsCode?mobile=" + data.mobile + "&platformCode=" + data.platformCode,),
    verifyUserBeforeLogin: (data, headers) => http.post("/apps/verify/verifyUserBeforeLogin", data, { headers }),
    verifyUserSmsCode: (data, headers) => http.post("/apps/verify/verifyUserSmsCode", data, { headers }),
    bind: (data, headers) => http.post("/apps/pc/bind", data, { headers }),
    mobileRegister: (data, headers) => http.post("/apps/pc/mobileRegister", data, { headers }),
    login: (data, headers) => http.post("/auth/oauth2/token", data, { headers }),
    wxPcLoginScanCallback: (data, headers) => http.get(`/apps/callback/wxPcLoginScanCallback?code=${data.code}&state=${data.state}`, { headers }),

    getUser: (data, headers) => http.get(`/apps/user/getUser`, data, { headers }),
};